import React from "react";
import ProjectCard from "./ProjectCard";
import Footer from "../Footer/Footer";
import { projectsData } from "../data/Projects";

export default function ProjectPage() {
  return (
    <>
      <div className="container">
        <div className="row project_row">
          <h1 style={{ color: "#50d890" }} className="text-center">
            My projects
          </h1>

          {projectsData &&
            projectsData.map((project) => {
              return (
                <div
                  className="col-lg-4 col-sm-6 my-3 project_card_box"
                  key={project.id}
                >
                  <ProjectCard
                    title={project.title}
                    image={project.image}
                    description={project.description}
                    githubUrl={project.githubUrl}
                    url={project.url}
                  />
                </div>
              );
            })}
        </div>
      </div>
      <Footer />
    </>
  );
}
